module.exports = (__webpack_require__(57985))(10972);